/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import React from 'react';
import classNames from 'classnames';
import { Popup } from '../popup/index.js';
import useConfig from '../hooks/useConfig.js';
import RangeInput from './RangeInput.js';
import useOverlayInnerStyle from '../select-input/useOverlayInnerStyle.js';
import '../popup/Popup.js';
import '../_chunks/dep-e43cf21c.js';
import '../_chunks/dep-2acfafca.js';
import 'react-transition-group';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import 'react-popper';
import '../hooks/useControlled.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-c1f93350.js';
import '../_chunks/dep-7dce2c26.js';
import '../_util/noop.js';
import '../_util/useAnimation.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../hooks/usePrevious.js';
import '../common/Portal.js';
import 'react-dom';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_util/easing.js';
import '../popup/hooks/useTrigger.js';
import 'react-is';
import '../popup/utils/ref.js';
import '../_util/composeRefs.js';
import '../popup/utils/transition.js';
import '../_util/useMutationObserver.js';
import '../_chunks/dep-01ce608f.js';
import '../_chunks/dep-77a54538.js';
import '../_util/useWindowSize.js';
import '../popup/defaultProps.js';
import '../popup/style/css.js';
import '../popup/type.js';
import '../_chunks/dep-92728dc5.js';
import 'tdesign-icons-react';
import '../input/index.js';
import '../input/Input.js';
import '../_util/useLayoutEffect.js';
import '../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import '../hooks/useGlobalIcon.js';
import '../input/InputGroup.js';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../input/defaultProps.js';
import '../_util/parseTNode.js';
import '../input/useLengthLimit.js';
import '../_common/js/log/index.js';
import '../_common/js/log/log.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../input/style/css.js';
import '../input/type.js';
import './defaultProps.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var RangeInputPopup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var name = "".concat(classPrefix, "-range-input-popup");
  var className = props.className,
    style = props.style,
    inputValue = props.inputValue,
    panel = props.panel,
    popupProps = props.popupProps,
    rangeInputProps = props.rangeInputProps,
    popupVisible = props.popupVisible,
    onInputChange = props.onInputChange,
    disabled = props.disabled;
  var _useOverlayInnerStyle = useOverlayInnerStyle(props),
    tOverlayInnerStyle = _useOverlayInnerStyle.tOverlayInnerStyle,
    innerPopupVisible = _useOverlayInnerStyle.innerPopupVisible,
    onInnerPopupVisibleChange = _useOverlayInnerStyle.onInnerPopupVisibleChange;
  var popupClasses = classNames([name, _defineProperty({}, "".concat(name, "--visible"), popupVisible !== null && popupVisible !== void 0 ? popupVisible : innerPopupVisible)]);
  return /* @__PURE__ */React.createElement("div", {
    ref: ref,
    style: style,
    className: classNames(name, className, popupClasses)
  }, /* @__PURE__ */React.createElement(Popup, _objectSpread(_objectSpread({
    hideEmptyPopup: true,
    content: panel,
    trigger: "click",
    placement: "bottom-left",
    visible: popupVisible !== null && popupVisible !== void 0 ? popupVisible : innerPopupVisible,
    onVisibleChange: onInnerPopupVisibleChange,
    disabled: disabled
  }, popupProps), {}, {
    overlayInnerStyle: tOverlayInnerStyle
  }), /* @__PURE__ */React.createElement(RangeInput, _objectSpread({
    disabled: disabled,
    status: props.status,
    tips: props.tips,
    value: inputValue,
    onChange: onInputChange
  }, rangeInputProps))));
});
RangeInputPopup.displayName = "RangeInputPopup";

export { RangeInputPopup as default };
//# sourceMappingURL=RangeInputPopup.js.map
